import React, { useState } from 'react';
import { Row, Col, Button, Modal, Form, InputGroup, Collapse } from 'react-bootstrap';
import { Group, Panel, Separator } from 'react-resizable-panels';
import { useMediaQuery } from 'react-responsive';
import { Text } from 'react-native';
import { api } from '../apiService';
import { toast } from 'react-toastify';
import { useAuth } from '../AuthContext';
import './animate.css'
import ai_svg from '../img/ai.svg';
import save_svg from '../img/save.svg';

const QuickApplyByUrl = ({ show, onChange }) => {
  const { user } = useAuth();
  const profile_email= user?.email
  const [openMore, setOpenMore] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);

  // --- Form State ---
  const [formData, setFormData] = useState({
    profile_email: user?.email,
    link: '',
    title: '',
    company: '',
    source: '',
    detail: {},
    description: ''
  });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const handleUrlFetch = async () => {
    setIsSpinning(true);
    const params = new URLSearchParams();
    params.append('job_link_url', formData.link);
    const [data, error] = await api.postEncoded(`create_job_by_url/?profile_email=${profile_email}`,params);
    //if (data) setFormData(data);
    if (data) setFormData({...formData,  
      title: data.title,
      company: data.company,
      source: data.source,
      detail: data.detail,
      description: data.description
    });
    setIsSpinning(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if(name=='detail')value = JSON.parse(value);
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setShowModal(!showModal);
  };

  //const handleSubmit = (e) => {
  const handleSubmit = async () => {
    setIsSubmitting(true);
    const [data, error] = await api.post('quick_apply/', formData);
    if (data) {
      toast.success("Application Saved Successfully!");
      onChange(data);
      setFormData({});
      handleClose();
    }
    setIsSubmitting(false);
  };


  return (
    <>
      <Modal show={showModal ^ show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            New Job by URL
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Header URL Input with Fetch Button */}
            <Form.Group className="mb-4">
              <Form.Label>Job Link URL</Form.Label>
              <InputGroup>
                <Form.Control
                  name="link"
                  placeholder="https://linkedin.com..."
                  value={formData.link}
                  onChange={handleInputChange}
                />
                <Button variant="outline-primary" onClick={handleUrlFetch}>
                   <img src={ai_svg} className={isSpinning ? 'spin' : ''}  height="32px" width="32px" title="" />&nbsp;
                   Auto-fill
                </Button>
              </InputGroup>
            </Form.Group>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Job Title</Form.Label>
                  <Form.Control
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Source</Form.Label>
                  <Form.Control
                    name="source"
                    value={formData.source}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div style={{ height: isMobile ? "60vh" : "230px", border: "1px solid #ddd" }}>
            <Group orientation={isMobile ? "vertical" : "horizontal"}> {/* Use 'orientation' instead of 'direction' */}
              <Panel defaultSize={30} minSize={20}>
                <div className="p-2 h-100">
                <Form.Label>Extracted Insights</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={8}
                  readOnly
                  style={{ fontFamily: 'monospace', fontSize: '0.85rem', backgroundColor: '#f8f9fa' }}
                  value={JSON.stringify(formData.detail, null, 2)}
                />
                </div>
              </Panel>

              <Separator className="bg-secondary" style={{ height: isMobile ? '4px' : '100%', width: isMobile ? '100%' : '4px',cursor: isMobile ? 'row-resize' : 'col-resize'}} />

              <Panel defaultSize={70} minSize={20}>
                <div className="p-2 h-100">
                <Form.Label className="h-5">Description</Form.Label>
                <Form.Control className="h-95 w-100"
                  as="textarea"
                  rows={8}
                  style={{ fontFamily: 'monospace', fontSize: '0.85rem', backgroundColor: '#f8f9fa' }}
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                />
                </div>
              </Panel>
            </Group>
            </div>

            {/* Extracted JSON Metadata Area */}
            <Form.Group className="mb-3">
            </Form.Group>

            {/* Best Practice: Progressive Disclosure for more info
            <div className="d-grid mt-3">
              <Button
                variant="link"
                onClick={() => setOpenMore(!openMore)}
                aria-controls="more-info-collapse"
                aria-expanded={openMore}
              >
                {openMore ? 'Show Less ↑' : 'Show More Details ↓'}
              </Button>
            </div>

            <Collapse in={openMore}>
              <div id="more-info-collapse" className="pt-3 border-top mt-2">
              </div>
            </Collapse>*/}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <>
            <Button variant="primary" onClick={handleClose}>Close</Button>
            <Button variant="success" onClick={handleSubmit} disabled={isSpinning || isSubmitting}>
              <img src={save_svg} className={isSubmitting ? 'spin' : ''}  height="32px" width="32px" title="" />&nbsp;
              {isSpinning || isSubmitting ? 'Sending to AI agent...' : 'Confirm & Submit'}
              </Button>
          </>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default QuickApplyByUrl;